import { render } from "./Messagelist.vue?vue&type=template&id=3f3b6ef4&ts=true"
import script from "./Messagelist.vue?vue&type=script&lang=ts"
export * from "./Messagelist.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__